<template>
  <div class="rewards" :class="cssType">
    <div class="rewards-title" :class="locale"></div>
    <div class="rewards-texts">
      <p class="text-1" v-html="eventDesc"></p>
      <p class="text-2">{{ $t('accum.rewards.eventTime') }}</p>
      <p class="text-3">{{ $t('accum.rewards.rewardEndTime') }}</p>
    </div>
    <div class="rewards-btns">
      <AccumButton @click="goRecharge">{{ $t('accum.goRecharge') }}</AccumButton>
      <AccumButton @click="showRecordDialog">{{ $t('accum.record') }}</AccumButton>
      <AccumButton :type="state.canReceiveOneKey ? 'green' : 'grey'" :disabled="!state.canReceiveOneKey" @click="rewardsAll">{{ $t('accum.rewardsAll') }}</AccumButton>
    </div>
    <div class="rewards-box">
      <div class="diff-diamond" v-html="diffDiamond"></div>
      <div class="rewards-list">
        <div
          class="rewards-item"
          :class="{ active: state.rechargeDiamond >= item.needPurchaseCount && item.status === 'canReceive', 'not-reach': state.rechargeDiamond < item.needPurchaseCount }"
          v-for="(item, index) in state.rewardList"
          :key="index"
        >
          <div class="props-img-list">
            <div class="props-img-item" v-for="(prop, i) in JSON.parse(item.propsGift)" :key="i">
              <img :src="prop.iconUrl" :alt="prop.name">
            </div>
          </div>
          <div class="props-detail-list" :class="locale">
            <div class="props-detail-item" v-for="(prop, i) in JSON.parse(item.propsGift)" :key="i">
              <div class="name">{{ prop.name }}</div>
              <div class="num">*{{ prop.count }}</div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="rewards-btn-list">
        <div class="rewards-btn-item" v-for="item in state.rewardList" :key="item.id">
          <div class="receive-btn can-receive" :class="locale" @click="handleReceiveReward(item)" v-if="item.status === 'canReceive'">{{ $t('accum.rewards.btnCanReceive') }}</div>
          <div class="receive-btn received" :class="locale" v-else-if="item.status === 'received'">{{ $t('accum.rewards.btnReceived') }}</div>
          <div class="receive-btn not-reach" :class="locale" v-else-if="item.status === 'notReach'">{{ $t('accum.rewards.btnNotReach') }}</div>
          <div class="receive-btn go-recharge" :class="locale" @click="goRecharge" v-else-if="item.status === 'goRecharge'">{{ $t('accum.goRecharge') }}</div>
          <div class="diamond-num" :class="{ 'not-reach': state.rechargeDiamond < item.needPurchaseCount }">
            <span>
              {{ item.needPurchaseCount }}
            </span>
            <span>
              {{ $t('payment.product.diamond') }}
            </span>
          </div>
        </div>
      </div>
      <ProgressBar class="progress-bar" :list="state.rewardList" :rechargeDiamond="state.rechargeDiamond" />
    </div>
    <Dialog v-model="state.rewardsAllDialog.visible" type="common">
      <div class="rewards-all-dialog-content">
        <div class="dialog-title">{{ $t('accum.rewardsAllDialog.title') }}</div>
        <div class="dialog-content">
          <div class="dialog-content-item" v-for="(item, index) in rewardsAllDialogContent" :key="index">
            <span v-html="item"></span>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.notStartDialog.visible" type="common" :showClose="false">
      <div class="not-start-dialog-content">
        <div class="dialog-title">{{ $t('payment.tip') }}</div>
        <div class="dialog-content">
          <p>{{ $t('payment.notStart') }}</p>
          <p>{{ $t('accum.rewards.eventTime') }}</p>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.receiveRewardDialog.visible" type="common">
      <div class="receive-reward-dialog-content">
        <div class="dialog-title">{{ $t('accum.rewardsAllDialog.title') }}</div>
        <div class="dialog-content">
          <div class="receive-reward-item" v-for="(item, index) in JSON.parse(state.receiveRewards.propsGift)" :key="index">
            <div class="receive-reward-item-icon">
              <div class="img-wapper">
                <img class="img" :src="item.iconUrl" :alt="item.name">
              </div>
            </div>
            <div class="receive-reward-item-name">
              {{ item.name }} *
            </div>
            <div class="receive-reward-item-num">
              {{ item.count }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.recordDialog.visible" type="common">
      <div class="record-dialog-content">
        <div class="dialog-title">{{ $t('accum.recordDialog.title') }}</div>
        <div class="dialog-content">
          <div class="record-table">
            <div class="thead">
              <div class="tr">
                <div class="th reach-node">
                  {{ $t('accum.recordDialog.reachNode') }}
                </div>
                <div class="th details">
                  {{ $t('accum.recordDialog.details') }}
                </div>
                <div class="th time">
                  {{ $t('accum.recordDialog.time') }}
                </div>
              </div>
            </div>
            <div class="tbody" v-if="state.rewardRecordList.length > 0">
              <div class="tr" v-for="item in state.rewardRecordList" :key="item.id">
                <div class="td reach-node">
                  {{ item.needPurchaseCount }} {{ $t('payment.product.diamond') }}
                </div>
                <div class="td details">
                  <div class="details-item" v-for="(prop, index) in JSON.parse(item.propsGift)" :key="index">
                    {{ prop.name }} * {{ prop.count }}
                  </div>
                </div>
                <div class="td time">
                  {{ item.createTime }}
                </div>
              </div>
            </div>
            <div class="empty-data" v-else>
              {{ $t('payment.noData') }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { computed, reactive, watch, defineEmits, onMounted, onUnmounted } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import AccumButton from '../AccumButton'
import ProgressBar from './components/ProgressBar'
import Dialog from '@/components/Dialog/ActAccum/index.vue'
import AccumApi from '@/config/accumApi'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
const store = useStore()
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const emit = defineEmits(['dialogOpen'])
const state = reactive({
  cpUserInfo: computed(() => store.state.cpUserInfo),
  rewardList: [],
  rechargeDiamond: 0,
  nextDiffDiamondNum: computed(() => {
    let res = 0;
    state.rewardList.find(item => {
      if (state.rechargeDiamond < item.needPurchaseCount) {
        res = item.needPurchaseCount - state.rechargeDiamond
        return true
      }
      return false
    })
    return res
  }),
  canReceiveAll: computed(() => { // 是否可以一键领取
    return state.rewardList.every(item => {
      return state.rechargeDiamond >= item.needPurchaseCount
    })
  }),
  receiveRewards: {},
  rewardRecordList: [],
  recordDialog: {
    visible: false,
  },
  rewardsAllDialog: {
    visible: false,
  },
  receiveRewardDialog: {
    visible: false,
  },
  notStartDialog: {
    visible: false,
  },
  canReceiveOneKey: computed(() => { // 是否可以一键领取
    return state.rewardList.some(item => item.status === 'canReceive')
  }),
})
watch(() => state.cpUserInfo, () => {
  reset()
}, { deep: true })
watch(() => store.state.locale, () => {
  reset()
})
watch(() => state.receiveRewardDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.rewardsAllDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.recordDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.notStartDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const eventDesc = computed(() => {
  const text = t('accum.rewards.eventDesc')
  return text.replace('[clickHere]', `
  <a href="${payUrl.value}" class="accum-link" target="_blank">
    [${t('accum.clickHere')}]
  </a>
  `)
})
const diffDiamond = computed(() => {
  if (state.canReceiveAll) {
    return t('accum.rewards.canReceiveAll')
  }
  const text = t('accum.rewards.diffDiamond')
  return text.replace('[diamondNum]', `
  <span style="color: #E9C452;">
    ${state.nextDiffDiamondNum}
  </span>
  `)
})
const rewardsAllDialogContent = computed(() => {
  const text = t('accum.rewardsAllDialog.content')
  const texts = text.split('\n')
  return texts.map(item => {
    return item.replace('[record]', `
      <span style="color: #5A90FF;">[${t('accum.record')}]</span>
    `)
  })
})
const goRecharge = () => {
  window.open(payUrl.value, '_blank')
}

const getRewardList = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumApi.getRewardList(params)
  const list = res.list || []
  list.sort((a, b) => a.needPurchaseCount - b.needPurchaseCount)
  list.forEach(item => {
    item.status = getStatus(item)
  })
  state.rewardList = res.list || []
  state.rechargeDiamond = res.totalMergePrdCount || 0
  let maxActivityStartTimestamp = 0
  list.forEach(item => {
    if(!maxActivityStartTimestamp || item.activityStartTimestamp > maxActivityStartTimestamp) {
      maxActivityStartTimestamp = item.activityStartTimestamp
    }
  })
  console.log('maxActivityStartTimestamp', maxActivityStartTimestamp)
  const serverTime = res.timestamp * 1000
  const startTimestamp = maxActivityStartTimestamp * 1000
  console.log('serverTime', new Date(serverTime).toLocaleString(), 'startTimestamp', new Date(startTimestamp).toLocaleString(), serverTime < startTimestamp)
  if (serverTime && startTimestamp && serverTime < startTimestamp) {
    state.notStartDialog.visible = true
    countDownHideNotStartDialog(serverTime, startTimestamp)
  }
}

// 计算时间，关闭弹窗
const countDownHideNotStartDialog = (serverTime, startTimestamp) => {
  // 计算服务器时间与设备时间的差异
  const serverToLocalDiff = serverTime - Date.now();

  const interval = setInterval(() => {
    // 将当前设备时间转换为服务器时间
    const now = Date.now() + serverToLocalDiff;
    if (now >= startTimestamp) {
      clearInterval(interval);
      state.notStartDialog.visible = false;
    }
  }, 1000);
}

const getRewardRecordList = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumApi.getRewardRecordList(params)
  console.log('getRewardRecordList', res)
  // debugger
  if (res.list) {
    state.rewardRecordList = res.list
  } else {
    state.rewardRecordList = []
  }
  
}

const showRecordDialog = async () => {
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  getRewardRecordList()
  state.recordDialog.visible = true
}

const rewardsAll = () => {
  console.log('rewardsAll', state.cpUserInfo.cpUserId, state.canReceiveOneKey)
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (!state.canReceiveOneKey) {
    return
  }
  oneKeyCollect()
}

const oneKeyCollect = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumApi.oneKeyCollect(params)
  console.log('oneKeyCollect', res)
  state.rewardsAllDialog.visible = true
  reset()
}

const getStatus = (item) => {
  // collectTimesLimit 奖励领取次数上限(活动配置)
  // collectedTimes 已领奖励次数
  // canCollectTimes 当前可领奖励次数上限
  if (item.collectTimesLimit === 0) { // 奖励领取时间结束后，服务端collectTimesLimit会返回0，统一展示goRecharge按钮
    return 'goRecharge'
  }
  if (item.collectedTimes >= item.collectTimesLimit) {
    return 'received'
  }
  if (item.collectedTimes < item.canCollectTimes) {
    return 'canReceive'
  }
  if (item.canCollectTimes < item.collectTimesLimit) {
    return 'notReach'
  }
  console.error('getStatus error', item)
}

const handleReceiveReward = async (item) => {
  state.receiveRewards = item
  const params = {
    buyId: item.buyId,
  }
  const res = await AccumApi.collectReward(params)
  console.log('collectReward', res)
  state.receiveRewardDialog.visible = true
  reset()
}

const reset = () => {
  init()
}

const init = () => {
  getRewardList()
}
init()
let count = 0
// 监听页面显示出来的时候就重新获取rewardList
onMounted(() => {
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      console.log('reset', count++)
      reset()
    }
  }
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 组件卸载时移除监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>